var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"width":800,"visible":_vm.serviceInfoModalVisible,"title":"","footer":null},on:{"cancel":_vm.closeModal}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.serviceInfo)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }